export const env = {
  REACT_APP_PASSWORD_MASK_SECRET: process.env.REACT_APP_PASSWORD_MASK_SECRET,
  REACT_APP_JOB_SHARING_URL: process.env.REACT_APP_JOB_SHARING_URL,
  STUDENT_ATS_TEMPLATE: process.env.STUDENT_ATS_TEMPLATE,
  CORPORATE_BULK_TEMPLATE: process.env.CORPORATE_BULK_TEMPLATE,
}

export const roleExportKeys = [
  'Role Published',
  'Role Name',
  'Company Name',
  'Eligible',
  'Ineligible',
  'Applied',
  'Not Applied',
  'Placed Students',
]
